var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.messages && _vm.messages.length > 0)?_c('div',{staticClass:"alert",class:_vm.alertClass},[_c('ul',_vm._l((_vm.messages),function(message,index){return _c('li',{key:'msg-' + index},[_vm._v(" "+_vm._s(message)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }